export const gitVersion = 'eudr-low-risk-1.0.13-498-gb7fef705';
